import React, { useState } from 'react';
import './style.css'; // Make sure you have the styles for the cards
import CaseStudyCard from '../case-study-card/CaseStudyCard';
import { Link } from 'react-router-dom';
import { newCaseStudies } from '../../data/new-case-study-data';

const caseStudyData = [
    {
        key: "industries",
        label: "Industries",
        subTabs: ["Show All", "Healthcare", "E-commerce & Retail", "Real Estate", "Automotive & Logistics", "EdTech", "Gaming & Entertainment"]
    },
    {
        key: "services",
        label: "Services",
        subTabs: [
            "Show All",
            "Artificial Intelligence",
            "Blockchain Solutions",
            "Custom Software Solutions",
            "Mobile App Solutions",
            "Web Development",
        ]
    },
    {
        key: "regions",
        label: "Regions",
        subTabs: ["Show All", "USA"]
    },
];

// const caseStudies = [
//     {
//         id: 1,
//         title: "KFC",
//         slug: 'kfc',
//         description: "Helping the Americana Group’s KFC to digitally transform their business by launching seven innovative mobile apps across global markets.",
//         image: "ai-self-study.avif", // Use a placeholder image URL
//         stats: [
//             { value: "22%", label: "Higher Conversion Rate" },
//             { value: "4.5", label: "Average Rating on Stores" },
//             { value: "30K+", label: "Orders per Day via App" },
//         ],
//         tags: {
//             industries: ["Retail"],
//             services: ["Mobile App Development"],
//             regions: ["Asia"]
//         }
//     },
//     {
//         id: 2,
//         title: "Dummy Case Study 1",
//         description: "This is a dummy case study to demonstrate how the cards will be displayed.",
//         image: "ai-self-study.avif",
//         stats: [
//             { value: "15%", label: "Increased Efficiency" },
//             { value: "$1M+", label: "Revenue Boost" },
//         ],
//         tags: {
//             industries: ["Finance"],
//             services: ["Web Development", "UI/UX"],
//             regions: ["North America"]
//         }
//     },
//     {
//         id: 3,
//         title: "Dummy Case Study 2",
//         description: "This case study highlights our success in the healthcare sector with innovative AI solutions.",
//         image: "ai-self-study.avif",
//         stats: [
//             { value: "99%", label: "Uptime" },
//             { value: "50+", label: "Features Implemented" },
//         ],
//         tags: {
//             industries: ["Healthcare"],
//             services: ["Artificial Intelligence"],
//             regions: ["Europe"]
//         }
//     },
//     {
//         id: 4,
//         title: "Dummy Case Study 2",
//         description: "This case study highlights our success in the healthcare sector with innovative AI solutions.",
//         image: "ai-self-study.avif",
//         stats: [
//             { value: "99%", label: "Uptime" },
//             { value: "50+", label: "Features Implemented" },
//         ],
//         tags: {
//             industries: ["Healthcare"],
//             services: ["Cloud & DevOps"],
//             regions: ["Europe"]
//         }
//     },
// ];

const CaseStudyTabs = () => {
    const [activeMain, setActiveMain] = useState("services");
    const [activeSub, setActiveSub] = useState("Show All");

    const handleMainTab = (tabKey) => {
        setActiveMain(tabKey);
        setActiveSub("Show All");
    };

    const activeMainData = caseStudyData.find(tab => tab.key === activeMain);

    const filteredCaseStudies = newCaseStudies.filter(cs => {
        if (activeSub === "Show All") {
            return true;
        }
        // Check if the active sub-tab exists in the tags for the active main category
        return cs.tags[activeMain]?.includes(activeSub);
    });

    return (
        <div className="case-study-tabs-main-box">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {/* Main Tabs */}
                        <div className="main-tabs">
                            {caseStudyData?.map((tab) => (
                                <span
                                    key={tab.key}
                                    className={`main-tab ${activeMain === tab.key ? "active" : ""}`}
                                    onClick={() => handleMainTab(tab.key)}
                                >
                                    {tab.label}
                                </span>
                            ))}
                        </div>

                        {/* Sub Tabs */}
                        {activeMainData && (
                            <div className="sub-tabs">
                                {activeMainData?.subTabs?.map((sub) => (
                                    <button
                                        key={sub}
                                        className={`sub-tab ${activeSub === sub ? "active" : ""}`}
                                        onClick={() => setActiveSub(sub)}
                                    >
                                        {sub}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Case Study Cards */}
                {/* <div className="row case-study-cards-container mt-5">
                    {filteredCaseStudies.map((cs, index) => (
                        <div key={index} className="col-lg-6 col-md-6 col-sm-12 mb-4">
                            <CaseStudyCard data={cs} />
                        </div>
                    ))}
                </div> */}

                <div className="row case-study-cards-container mt-5">
                    {filteredCaseStudies?.map((cs, index) => {
                        if (index === 0 && activeSub === "Show All") {
                            return (
                                <div key={index} className="col-lg-12 col-md-12 col-sm-12 mb-4">
                                    <Link to={`/case-studies/${cs?.slug}`} style={{ textDecoration: 'none' }}>
                                        <div
                                            className="featured-case-study-card"
                                            style={{ backgroundImage: `url(${cs?.mainImage})` }}
                                        >
                                            <h5>{cs.mainHeading}</h5>
                                            <p> {cs?.mainDescription?.split(" ").length > 10
                                                ? cs?.mainDescription?.split(" ").slice(0, 10).join(" ") + "....."
                                                : cs?.mainDescription}</p>
                                            <div className="stats">
                                                {cs?.mainStats?.map((stat, statIndex) => (
                                                    <div key={statIndex} className="stat-item">
                                                        <h3>{stat.value}</h3>
                                                        <p>{stat.text}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            );
                        } else {
                            return (
                                <div key={index} className="col-lg-6 col-md-6 col-sm-12 mb-4">
                                    <CaseStudyCard data={cs} />
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
        </div>
    );
};

export default CaseStudyTabs;